export default __webpack_public_path__ + "static/media/linkedIn.e4235dff.svg";